import { Group } from "lucide-react";
import WorkFlowPage from "../pages/WorkFlowPage";

// reducers/tabReducer.js
const data = {
    tab: "0",
    interview: { //ok
        id: 0,
        causas: [],
        content: "", // HOJA DE ATENCION
        fecha: "",
        origen: "",
    },
    customer: {},
    customerFormatted: {},
    contractFull: {},
    CttosOld: [],
    Sucursales: [],
    Cuotas: [],
    preAnexo: { isAnexo: false, codCtto: '', codAnexo: '', motivo: 'ctto'/* ctto,venta,act,cambio */, nuevoMonto: 0 }
};

const reset = {
    tab: "0",
    interview: { //ok
        id: 0,
        causas: [],
        content: "", // HOJA DE ATENCION
        fecha: "",
        origen: "",
    },
    customer: {},
    customerFormatted: {},
    contractFull: {},
    CttosOld: [],
    Sucursales: [],
    Cuotas: [],
    preAnexo: { isAnexo: false, codCtto: '', codAnexo: '', motivo: 'act'/* venta,act,cambio */, nuevoMonto: 0 }
};

export default function tabReducer(state = data, action) {
    switch (action.type) {
        case 'SET_TAB':
            return { ...state, tab: action.payload }
        case 'SET_INTERVIEW':
            return {
                ...state,
                interview: {
                    ...state.interview,
                    ...action.payload
                }
            };
        case 'SET_CUSTOMER':
            return { ...state, customer: action.payload }
        case 'SET_CUSTOMER_FORMATTED':
            return { ...state, customerFormatted: action.payload }
        case 'SET_CONTRACT':
            return { ...state, contract: action.payload }
        case 'SET_CONTRACT_FULL':
            return { ...state, contractFull: action.payload }
        case 'SET_CTTOS_OLD':
            return { ...state, CttosOld: action.payload }
        case 'SET_SUCURSALES':
            return { ...state, Sucursales: action.payload }
        case 'SET_CUOTAS':
            return { ...state, Cuotas: action.payload }
        case 'SET_PREANEXO':
            return { ...state, preAnexo: action.payload }
        case 'RESET_STATE':
            return reset;
        default:
            return state;
    }
};

export const setTab = (tab) => ({
    type: 'SET_TAB',
    payload: tab,
});

export const setCustomer = (customer) => ({
    type: 'SET_CUSTOMER',
    payload: customer,
});

export const setCustomerFormatted = (customerFormatted) => ({
    type: 'SET_CUSTOMER_FORMATTED',
    payload: customerFormatted,
});

export const setContractFull = (contractFull) => ({
    type: 'SET_CONTRACT_FULL',
    payload: contractFull,
});

//legado GCC mysql
export const setContractsOld = (contractsOld) => ({
    type: 'SET_CTTOS_OLD',
    payload: contractsOld,
});

export const setSucursales = (Sucursales) => ({
    type: 'SET_SUCURSALES',
    payload: Sucursales,
});

export const setInterview = (interview) => ({
    type: 'SET_INTERVIEW',
    payload: interview,
});

export const setCuotas = (cuotas) => ({
    type: 'SET_CUOTAS',
    payload: cuotas,
});

export const resetTabState = () => ({
    type: 'RESET_STATE'
});

export const setPreAnexo = (data) => ({
    type: 'SET_PREANEXO',
    payload: data
})